<script>
  import { format } from 'svelte-i18n';
  import { Button, Modal } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';
  import { Loader } from '@client/components/loader';
  import { getNotificationsContext } from '@client/components/notifications';

  import { UsersService } from '@client/services/users';

  import MdmForm from '../forms/mdm-form.svelte';

  const { addNotification } = getNotificationsContext();

  export let show = false;

  let formRef;
  let error = '';
  let updating = false;
  let initializing = false;

  let users = '';
  let selectedDomains = [];
  let actionItem = null;
  let authcode = '';

  const resetModal = () => {
    show = false;
    error = '';
    formRef?.reset();
  };

  const onUpdate = async () => {
    const mdmdomains = selectedDomains.map(({ value }) => value).join('\n');
    const action = actionItem.value;
    const payload = {
      mdmusers: users,
      mdmdomains,
      authcode
    };

    error = '';

    let response = null;

    updating = true;

    if (action === 'assign') {
      response = await UsersService.assignUsersMDM(payload);
    } else {
      response = await UsersService.unassignUsersMDM(payload);
    }

    updating = false;

    if (response.status && response.status !== 200) {
      error = $format('label.FAILURE.MDM_UPDATE', {
        values: {
          verb: action,
          users: users.replace(/\n/g, ','),
          domains: mdmdomains.replace(/\n/g, ','),
          message: response.message
        }
      });
      return;
    }

    addNotification({
      text: $format('label.SUCCESS.MDM_UPDATE', { values: { verb: action } }),
      type: 'success',
      autohide: 2500,
      position: 'top-right'
    });

    resetModal();
  };

  $: show === false && resetModal();
</script>

<Modal bind:isOpen={show} size="md">
  <Loader backdrop show={updating || initializing} />
  <div class="manage-mdm-modal modal--content">
    <button class="close" on:click={() => (show = !show)}>
      <Icon name="x" />
    </button>

    <div>
      <h1>{$format('label.MANAGE_MDM_ACCOUNTS')}</h1>

      <MdmForm
        bind:this={formRef}
        bind:users
        bind:selectedDomains
        bind:actionItem
        bind:authcode
        bind:initializing
        {error}
      />
    </div>
    <div class="footer-actions">
      <Button
        color="primary"
        disabled={selectedDomains === undefined || !users || !actionItem || !authcode}
        on:click={onUpdate}
      >
        {$format('label.UPDATE')}
      </Button>
    </div>
  </div>
</Modal>

<style lang="scss" src="./mdm.scss"></style>
